// extracted by mini-css-extract-plugin
module.exports = {"root":"PageTitle_root__1r30k","left":"PageTitle_left__VK0KX","title":"PageTitle_title__110W0","right":"PageTitle_right__3TXmk"};